import React, {SetStateAction, useEffect, useState} from "react";
import {Card, Col} from "react-bootstrap";
import {useTranslation} from "react-i18next";
import Select from "react-select";
import {AdminCategoryService} from "../../category/service";
import {ErrorToast} from "../../../shared/toasters/toasters";
import {useSelector} from "react-redux";
import {RootState} from "../../../store";
import {ISiteSettings} from "../interface";
import {IDropdown} from "../../newsAutoInformation/components/CreateForm";
import {OnChangeValue} from "react-select/dist/declarations/src/types";
import {capitalize} from "lodash";

interface IProps {
    state: ISiteSettings[],
    setState: React.Dispatch<SetStateAction<ISiteSettings[]>>,
    submitHandler: (indexNumber: number) => void;
}

export interface ISettingsCategory {
    id: number;
    name: string
}

export const CreateForm = ({state, setState, submitHandler}: IProps) => {
    const {t} = useTranslation();
    const {siteSettings} = useSelector((state: RootState) => state.enum);
    const [categoryList, setCategoryList] = useState<IDropdown[]>();
    const selectHandler = (e: OnChangeValue<IDropdown, false>, index: number, name: string) => {
        let onChangeValue = [...state];
        (onChangeValue as any)[index][name] = e?.value;
        setState(onChangeValue);
    };
    const changeHandler = (event: React.ChangeEvent<HTMLInputElement>, index: number) => {
        const {name, value} = event.target;
        let onChangeValue = [...state];
        (onChangeValue as any)[index][name] = value;
        setState(onChangeValue);
    };
    useEffect(() => {
        AdminCategoryService.getAll({perPage: 0, page: 1})
            .then((response) => {
                const {data} = response;

                setCategoryList(
                    data?.items.map((item: ISettingsCategory) => ({label: item.name, value: item.id}))
                );
            })
            .catch((error) => ErrorToast(error));
    }, []);
    return (
        <Card>
            <Card.Body>
                {state &&
                    state?.map((item, index: number) => {
                        return (
                            <div className="row d-flex align-items-end my-3" key={index}>
                                <Col md={3}>
                                    <label htmlFor="title" className="required-field">
                                        {t("global.title")}
                                    </label>
                                    <input
                                        type="text"
                                        name="title"
                                        className="form-control"
                                        required
                                        onChange={(e) => changeHandler(e, index)}
                                        value={item?.title}
                                    />
                                </Col>
                                <Col md={2} className="">
                                    <label htmlFor="category" className="required-field">
                                        {t("table_headers.position")}
                                    </label>
                                    <Select
                                        isDisabled={true}
                                        key={item?.key ?? index}
                                        name="key"
                                        defaultValue={
                                            item?.key && {
                                                value: item?.key,
                                                label: capitalize(item?.key),
                                            }
                                        }
                                        className="react-select-field"
                                        onChange={(e) => selectHandler(e as unknown as IDropdown, index, "key")}
                                        options={(siteSettings as string[])?.map((site: string) => ({
                                            value: site,
                                            label: capitalize(site),
                                        }))}
                                    />
                                </Col>
                                <Col md={3} className="">
                                    <label htmlFor="category" className="required-field">
                                        {t("table_headers.category")}
                                    </label>
                                    <Select
                                        className="react-select-field"
                                        onChange={(e) => selectHandler(e, index, "category")}
                                        options={categoryList}
                                        value={categoryList?.find(
                                            (category) => category?.value === item?.category
                                        )}
                                    />
                                </Col>
                                <Col md={3}>
                                    <label htmlFor="link" className="required-field">
                                        {t("global.link")}
                                    </label>
                                    <input
                                        type="text"
                                        name="url"
                                        className="form-control"
                                        onChange={(e) => changeHandler(e, index)}
                                        value={item?.url}
                                    />
                                </Col>
                                <Col md={1}>
                                    <button
                                        className="btn btn-primary"
                                        onClick={() => submitHandler(index)}
                                    >
                                        {t("global.save")}
                                    </button>
                                </Col>
                            </div>
                        );
                    })
                }
                {state?.length < 2 && <div className={'col-12 d-flex justify-content-end'}>
                    <button className="btn btn-primary"
                            onClick={() => setState(prev => prev.concat([{
                                title: "",
                                category: null,
                                key: siteSettings?.[state?.length] ?? ''
                            }]))}>
                        {t('global.add')}
                    </button>
                </div>}
            </Card.Body>
        </Card>
    );
};
